import { Input } from "antd";
import React, { useState } from "react";

export const ContentInputField = ({
  name,
  onChange,
  value,
  errors,
  required,
  filter,
  disabled,
  min,
  placeholder,
  type,
  addonAfter,
  maxLength,
  style,
}) => {
  const [localError, setLocalError] = useState("");

  const combinedError = localError || errors;

  // wrapper for onChange
  const handleChange = (e) => {
    // normalize value
    const stringValue =
      e.target.value !== null && e.target.value !== undefined
        ? String(e.target.value)
        : "";

    // Check if first character is a blank space
    const startsWithSpace = stringValue.startsWith(" ");
    if (startsWithSpace) {
      const errMsg = `${name ? name : ""} cannot start with a space.`;
      setLocalError(errMsg);
    } else {
      setLocalError("");
    }

    const cleanedValue = e.target.value.replace(/^\s+/, ""); // remove only leading spaces
    if (onChange) {
      onChange({ ...e, target: { ...e.target, value: cleanedValue } });
    }
  };

  return (
    <div className="d-flex flex-column">
      {!filter && (
        <label className="font-weight-bolder font-size-lg">
          {name} {required && <span style={{ color: "red" }}>*</span>}
        </label>
      )}
      <Input
        placeholder={placeholder || name}
        min={min}
        type={type || "text"}
        value={value}
        maxLength={maxLength}
        className={`${combinedError ? "invalid" : ""} ${
          addonAfter ? "" : "form-control"
        }`}
        onChange={handleChange}
        disabled={disabled}
        addonAfter={addonAfter}
        style={style}
      />
      <small className="text-danger text-capitalize">{combinedError}</small>
    </div>
  );
};
